import { postCreateContactPerson } from "src/api/queries/order-portal-bff";
import { AXIOS_INSTANCE } from "src/api/mutator/axios";
import { useNotification } from "src/composables/useNotification";
import type { ContactFormData } from "src/components/form/ContactFields.vue";
import { type CreateTicketContactPersonDTO, CreateTicketContactPersonDTOReference } from "src/api/models";
import type { ContactPersonFilterDTO, FetchAllTicketContactPersonsResponse } from "src/api/models";
import type { PaginationParams } from "src/composables/ticket-entities/types";

export interface TicketContactPersonResponse extends ContactFormData {
  id: string;
  description?: string;
  created_at?: string;
}

export function useTicketContactPersonService() {
  const { showError, showSuccess } = useNotification();

  async function fetchTicketContactPersons(
    filters?: ContactPersonFilterDTO,
    pagination?: PaginationParams,
  ): Promise<FetchAllTicketContactPersonsResponse> {
    try {
      const response = await AXIOS_INSTANCE.post<FetchAllTicketContactPersonsResponse>(
        '/api/ticket-contact-persons',
        filters ?? {},
        {
          params: {
            limit: pagination?.limit ?? 50,
            page: pagination?.page ?? 1,
          },
        },
      );
      return response.data;
    } catch (error) {
      showError();
      throw error;
    }
  }

  async function createTicketContactPerson(contactPerson: ContactFormData, reference: CreateTicketContactPersonDTOReference) {
    try {

      const data: CreateTicketContactPersonDTO = {
        first_name: contactPerson.first_name || null,
        last_name: contactPerson.last_name || null,
        email: contactPerson.email || null,
        phone_number: contactPerson.phone_number || null,
        mobile_phone_number: contactPerson.mobile_phone_number || null,
        reference: reference ?? CreateTicketContactPersonDTOReference.site,
      };

      const response = await postCreateContactPerson(data);
      showSuccess({ message: 'Contact person created successfully' });
      return response;
    } catch (error) {
      showError();
      throw error;
    }
  }

  return {
    fetchTicketContactPersons,
    createTicketContactPerson,
  };
}
